import { Directive, EventEmitter, InputSignal, Output } from '@angular/core';
import { ActionEvent, SimpleAction } from '@infodata-group/inf-commons';

@Directive()
export abstract class TouchAction {
  private timeout: any;

  public abstract action: InputSignal<SimpleAction<any>>;

  @Output() actionClick = new EventEmitter<ActionEvent>();
  @Output() longPress = new EventEmitter<ActionEvent>();

  protected onTouchEnd(): void {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.actionClick.emit(new ActionEvent('click', this.action()));
    }
  }
  protected onTouchStart($event): void {
    $event.preventDefault();
    this.timeout = setTimeout(() => {
      this.longPress.emit(new ActionEvent('click', this.action()));
      this.timeout = null;
    }, 700);
  }
}
